module.exports = __webpack_public_path__ + "static/media/kevin.14e0bc1b.jpeg";